import { InjectionToken } from '@angular/core';
import { IconsConfig } from '@prlw/libs/icons/icons.module';

export const ICONS_CONFIG = new InjectionToken<IconsConfig>('icons-config');
